import { render, staticRenderFns } from "./EmotionGame.vue?vue&type=template&id=ecac82a6&scoped=true&"
import script from "./EmotionGame.vue?vue&type=script&lang=js&"
export * from "./EmotionGame.vue?vue&type=script&lang=js&"
import style0 from "./EmotionGame.vue?vue&type=style&index=0&id=ecac82a6&scoped=true&lang=scss&"
import style1 from "./EmotionGame.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecac82a6",
  null
  
)

export default component.exports